import getActiveContentTab from './getActiveContentTab';
import { TabType } from '../store/schema/TabViewState';
import type SecondaryReadingPaneTabData from '../store/schema/SecondaryReadingPaneTabData';

/**
 * When a secondary reading-pane tab is active, returns the
 * item/conversation ID (`data.id.Id`) for that tab so callers
 * can resolve it to a row key via `getRowKeysFromRowIds`.
 * Returns `undefined` otherwise.
 */
export default function getActiveSecondaryReadingPaneTabItemId(): string | undefined {
    const activeTab = getActiveContentTab();
    if (activeTab?.type === TabType.SecondaryReadingPane) {
        const tabData = activeTab.data as SecondaryReadingPaneTabData | undefined;
        return tabData?.id?.Id;
    }
    return undefined;
}
